import styled from 'styled-components';

export const StyledUserContent = styled.div`
  padding: 2.4rem 0;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 0.8rem;

  p {
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    margin-inline-end: 0.8rem;
  }

  p[data-text='user-name'] {
    font-size: 2.2rem;
  }

  & > div {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }
`;
